import Modal from "react-native-modal";
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';
import FontAwesome from "@expo/vector-icons/FontAwesome";

// Shown from the "create post" FAB when the user tries to create a user post without being signed in.
export default function SignInRequiredModal({ visible, dismiss, onCreateAccount }) {

  return (
    <Modal
      isVisible={visible}
      hasBackdrop={true}
      backdropColor="#EBBB40"
      backdropOpacity={0.6}
      onBackdropPress={dismiss}
    >
      <View style={styles.container}>
        <FontAwesome
          name="user-circle-o"
          size={32}
          color="#674FE0"
          style={styles.icon}
        />

        <Text style={styles.title}>Account Required</Text>

        <Text style={styles.message}>
          You need to have an account to make a post, add a reaction, or comment.
        </Text>

        <TouchableOpacity style={styles.primaryButton} onPress={onCreateAccount}>
          <Text style={styles.primaryButtonText}>Sign In / Create Account</Text>
        </TouchableOpacity>

        <TouchableOpacity style={styles.closeButton} onPress={dismiss}>
          <Text style={styles.closeButtonText}>Close</Text>
        </TouchableOpacity>
      </View>
    </Modal>
  );
}


const styles = StyleSheet.create({
  container: {
    width: 280,
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 12,
    padding: 20,
    alignItems: 'center',
  },
  icon: {
    marginBottom: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#25292e',
    marginBottom: 10,
    textAlign: 'center',
  },
  message: {
    fontSize: 14,
    color: '#555',
    textAlign: 'center',
    marginBottom: 20,
    lineHeight: 20,
  },
  primaryButton: {
    backgroundColor: '#674FE0',
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 20,
    width: '100%',
    alignItems: 'center',
    marginBottom: 10,
  },
  primaryButtonText: {
    color: '#fff',
    fontSize: 15,
    fontWeight: '600',
  },
  closeButton: {
    paddingVertical: 8,
    paddingHorizontal: 20,
  },
  closeButtonText: {
    color: '#674FE0',
    fontSize: 14,
    fontWeight: '500',
  },
});
